import { Company } from './company';

/**
 * Splits the companies of the user into the ones he owns and the ones he is only linked to.
 * Keeps the order received: the server already orders favorites, recent access and name.
 */
export function splitUserCompanies(companies: Company[], userId: string): { ownCompanies: Company[], linkedCompanies: Company[] } {
  const ownCompanies: Company[] = [];
  const linkedCompanies: Company[] = [];
  for (const company of companies) {
    if (company.owner === userId) {
      ownCompanies.push(company);
    } else {
      linkedCompanies.push(company);
    }
  }
  return { ownCompanies, linkedCompanies };
}
